module.exports = __webpack_public_path__ + "static/media/dent.434607f1.svg";